import { useQuery } from '@tanstack/react-query';

import { TableQueryState } from 'components/Table/useTableQueryState';
import { CoreBaseConfiguration } from './BaseConfiguration';
import { SmartTextOptionGroupsApi } from './core';

export const SmartTextOptionGroupApiKeys = {
  GET_SMART_TEXT_OPTION_GROUPS: 'smartTextOptionGroups',
};

const client = new SmartTextOptionGroupsApi(new CoreBaseConfiguration());

export const useGetSmartTextOptionGroups = (state?: TableQueryState) => {
  return useQuery({
    queryKey: [SmartTextOptionGroupApiKeys.GET_SMART_TEXT_OPTION_GROUPS, state],
    queryFn: () =>
      client.smartTextOptionGroupsGet({
        pageNumber: state?.pagination.pageIndex,
        size: state?.pagination.pageSize,
        orderByProperty: state?.sorting[0]?.id,
        ascending: state?.sorting[0]?.desc === false,
        searchTerm: state?.globalFilter,
      }),
  });
};
